<template>
  <div class="pagebox" v-if="show">
    <div class="pagetitle">
      <div class="title">您好，欢迎来到中玺拍卖！</div>
      <!-- <ul class="tab">
        <template v-for="item in tablist" >
          <li class="tab-item" :class="getpagetype.remark==item.remark?'active':''" 
          :key="item.remark" @click="handleClick(item)">{{item.dictLabel}}</li>
        </template>
      </ul> -->
      <div class="loginbtnlist" >
        <el-dropdown v-if="getuser">
          <span class="el-dropdown-link">
            <i class="el-icon-user-solid" /> 
            {{getuser.userName}} 
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="topath('/my')">个人中心</el-dropdown-item>
            <el-dropdown-item @click.native="toexit('/login')">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <template v-else>
          <el-button type="text" @click="tologo()">商家登录</el-button>
          <el-button type="text" @click="topath('/register')">免费注册</el-button>
          <el-button type="text" @click="topath('/login')">竞买方登录</el-button>
        </template>
      </div>
    </div>
    <!-- <div class="titleTxt">
        <span v-if="getpagetype.remark!='auction_notice_type'">中玺平台 · </span>{{getpagetype.dictLabel}}
      </div> -->
  </div>
</template>

<script>
export default {
  name: 'pagetitle',
  data() {
    return {
      show:false,
      tablist:[],
    }
  },
  created(){
    this.getLogotitle()
  },
  computed:{
    getuser(){
      return this.$store.getters.getuserinfo
    },
    getpagetype(){
      return this.$store.getters.getpagetype
    }
  },
  methods:{
    toexit(){
      localStorage.removeItem('token');
      localStorage.removeItem('userinfo');
      window.location.href='/'
    },
    getLogotitle(){
      this.HTTP.get(this.$api.dictByType+'auction_notice_type',{})
      .then((res)=>{
        this.tablist = res.data;
        this.tablist.unshift({remark:'auction_notice_type',dictLabel:'中玺平台'})
        this.$store.commit('setpagetype',this.tablist[0])
        this.show = true;
      })
    },
    handleClick(act){
      this.$store.commit('setpagetype',act)
      this.topath('/')
    },
    tologo(){
      window.location.href = 'https://admin.zhongxipaimai.com/'
    }
  }
}
</script>

<style lang="scss">
.pagebox{
  background: #f7f7f7;
  div.title{
    padding: 12px 0;
  }
  .pagetitle {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tab{
      display: flex;
      .tab-item{
        width: 120px;
        text-align: center;
        padding: 10px;
        font-size: 14px;
        font-weight: bold;
        border: 1px solid $--color-primary;
        cursor: pointer;
      }
      .tab-item:hover,.tab-item.active{
        background: $--color-primary;
        color: #fff;
      }
    }
  }
  .titleTxt{
    text-align: center;
    color: #fff;
    padding: 15px;
    font-size: 26px;
    background: $--color-primary;
  }
}


</style>
